import React from 'react';
import styles from './loaders.module.scss';

export default function LoaderContainer({ children }) {
  return <div className={styles.loader_container}>{children}</div>;
}
